/**
 * Thin wrapper for legacy callers: maps text → body and uses shared emailService.
 * Recovery still uses /api/send-recovery on same origin as email API.
 */
import { sendEmail, getEmailApiOrigin, getPortalUrlForEmails } from '../services/emailService';

export async function sendAppEmail({ to, subject, text }) {
  if (!to || !to.trim()) return;
  const result = await sendEmail({
    to: to.trim(),
    subject: subject || 'ECDT Portal',
    body: text != null ? String(text) : '',
  });
  if (!result.success) {
    console.warn('[sendAppEmail]', result.error);
    throw new Error(result.error || 'Email failed');
  }
}

export async function sendRecoveryEmail({ email, redirectTo }) {
  const trimmed = (email && typeof email === 'string' ? email : '').trim();
  if (!trimmed) return;
  const origin = getEmailApiOrigin();
  const url = origin ? `${origin}/api/send-recovery` : '/api/send-recovery';
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: trimmed,
      redirectTo: redirectTo || `${getPortalUrlForEmails()}/reset-password`,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || res.status);
  return data;
}
